import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UnifiedDashboard from '../pages/UnifiedDashboard';
import CustomerDashboard from '../pages/CustomerDashboard';

/**
 * SmartDashboardRedirect component that renders the appropriate dashboard
 * based on the user's role (admin vs customer).
 * 
 * This ensures that even if users access legacy routes like /app or /dashboard,
 * they'll see the correct dashboard for their role.
 */
const SmartDashboardRedirect = () => {
    const { user, loading } = useAuth();

    // Show loading state while checking auth
    if (loading) {
        return (
            <div className="bg-dark text-light d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-secondary">Loading...</p>
                </div>
            </div>
        );
    }

    // If not logged in, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Admin users see the UnifiedDashboard (admin dashboard)
    if (user.is_admin) {
        return <UnifiedDashboard />;
    }

    // Non-admin users (customers) see the CustomerDashboard
    return <CustomerDashboard />;
};

export default SmartDashboardRedirect;

